export default __webpack_public_path__ + "static/media/2020 Protein Plus - hero.4e0d51ce.jpg";